import $ from 'jquery';

import { isPublicMode } from '../../services/publicMode';

angular
  .module('estoffice.legacy')
  .controller('RoomsCtrl', roomsCtrl)
  .controller('AreaCtrl', areaCtrl)
  .controller('PopupCtrl', popupCtrl)
  .controller('AptCtrl', aptCtrl)
  .controller('FeaturesCtrl', featuresCtrl)
  .controller('ImageCtrl', imageCtrl)
  .controller('PriceCtrl', priceCtrl)
  .controller('ReviewCtrl', reviewCtrl)
  .controller('ProductionCtrl', productionCtrl)
  .controller('ProductionLocationCtrl', productionLocationCtrl);

function roomsCtrl($rootScope, $scope, unit, api, $timeout) {
  $scope.rooms = {};
  $scope.room = {};
  unit.count.rooms = $scope.rooms;
  unit.columnChange = false;
  $scope.countRooms = [];
  $timeout(function () {
    $scope.room.type = 'rooms';
    $scope.room.url = api.rooms.change.replace(
      '{{sectionId}}',
      $rootScope.sectionId,
    );
    $rootScope.updateStatistic();
  });
  $rootScope.updateStatistic = function () {
    $scope.countRooms = unit.countOfValue(unit.count.rooms);
    unit.countRooms = $scope.countRooms;
    $scope.totalRooms = unit.totalRooms();
    $scope.countOffice = unit.count.offices;
  };
}

function areaCtrl($rootScope, $scope, unit, api, $timeout) {
  $rootScope.requestLoader = false;
  unit.columnChange = false;
  $scope.floorColumnType = 'area_total';
  $scope.addSelector = `.${$scope.floorColumnType}[disabled != disabled]`;
  $scope.area = {
    area_total: true,
    area_living: false,
    area_kitchen: false,
    area_office: false,
    showAll: false,
  };

  $timeout(function () {
    $scope.areaUrl = api.area.change.replace(
      '{{sectionId}}',
      $rootScope.sectionId,
    );
  }, 5);

  $scope.toggleOffice = false;

  $scope.changeFloorType = function (event) {
    event.preventDefault();
    $scope.toggleOffice = !$scope.toggleOffice;

    if ($scope.toggleOffice) {
      $scope.area.area_total = false;
      $scope.area.area_living = false;
      $scope.area.area_kitchen = false;
      $scope.area.showAll = false;
    } else {
      $scope.area.area_total = true;
    }
  };

  $scope.change = function () {
    $scope.toggleOffice = false;

    if ($scope.area.showAll) {
      $scope.area.area_total = true;
      $scope.area.area_living = true;
      $scope.area.area_kitchen = true;
    } else {
      $scope.addSelector = '.area_total[disabled != disabled]';
      $scope.area.area_total = true;
      $scope.area.area_living = false;
      $scope.area.area_kitchen = false;
    }
  };

  $scope.changeType = function (type) {
    $scope.toggleOffice = false;
    $scope.floorColumnType = type;
    $scope.addSelector = `.${$scope.floorColumnType}[disabled != disabled]`;
    angular.forEach($scope.area, function (element, i) {
      $scope.area[i] = i === type;
    });
    $scope.area.area_office =
      $scope.area.area_living || $scope.area.area_kitchen ? true : false;
  };

  $scope.changePlotSize = function (event) {
    event.preventDefault();
    $scope.toggleOffice = !$scope.toggleOffice;
    $scope.floorColumnType = 'area_total';
    $scope.addSelector = `.${$scope.floorColumnType}[disabled != disabled]`;

    if ($scope.toggleOffice) {
      $scope.area.area_total = false;
      $scope.area.area_living = false;
      $scope.area.area_kitchen = false;
      $scope.area.showAll = false;
    } else {
      $scope.area.area_total = true;
    }
  };

  $scope.changeAll = function () {
    $scope.toggleOffice = false;

    if ($scope.area.showAll) {
      $scope.area.area_total = true;
      $scope.area.area_living = true;
      $scope.area.area_kitchen = true;
    }
  };
}

function popupCtrl(
  $scope,
  /** @type {angular.material.IDialogService} */ $mdDialog,
  request,
  $compile,
  unit,
  $timeout,
  $rootScope,
  $window,
) {
  $scope.modal = {};
  $scope.modal.title = $scope.title;
  $scope.modal.contentLoading = true;
  $scope.modal.showSubmitText = false;
  $scope.modal.submitText = $scope.afterSubmitText;

  $scope.initCountry = function () {
    $scope.selectCountry = '0';
    unit.country = $(
      `#country_id option[value=${$scope.selectCountry}]`,
    ).text();
  };

  $scope.changeCountry = function () {
    unit.country = $(
      `#country_id option[value=${$scope.selectCountry}]`,
    ).text();
  };

  if ($scope.name) {
    $scope.modal.name = $scope.name;
  }

  request.post($scope.url, {}, function (response) {
    $scope.modal.content = response.data;

    // Добавил, чтобы высота модалки увеличивалась плавно
    $scope.modal.setMaxHeight = '-height-animated';

    $compile(angular.element('.b-popup'))($scope);

    // добавил, чтобы контент модалки проявлялся не сразу. С overflow:hidden были проблемы
    $scope.modal.setOpacity = { opacity: '1' };
  });

  $scope.showSubmitText = function () {
    $scope.modal.showSubmitText = true;
    $timeout(function () {
      $scope.modal.showSubmitText = false;
    }, 5000);
  };

  $scope.reloadAfterPause = function () {
    $timeout(function () {
      $scope.closeDialog();
    }, 1000);
  };

  $scope.closeDialog = function () {
    $mdDialog.hide();

    // если создали новый объект(ы) нужно перезагрузить страницу
    $timeout(function () {
      if ($rootScope.newObjectAdded || $rootScope.newSectionAdded) {
        $rootScope.newObjectAdded = false;
        $rootScope.newSectionAdded = false;
        $window.location.reload();
      }
    }, 300);
  };
}

function aptCtrl($scope, $timeout) {
  $scope.skipOffice = true;
  $scope.splittedFirst = true;
  $scope.tower = {};
  $scope.tower.towerSeparator = '';
  $scope.tower.floorSeparator = '';
  $scope.tower.aptSeparator = '';
  $scope.tower.towerAlphabet = '';
  $scope.autoSet = function (event) {
    event.preventDefault();
  };
  $scope.aptNum = {};
  $scope.num = {};

  $scope.changeAptNum = function (type) {
    if (type == 'first') {
      $scope.aptNum.last = '';
    } else {
      $scope.aptNum.first = '';
    }
  };

  $scope.showNumColumn = function () {
    angular.element('input.b-textfield.-display_inline.num').hide();
    $scope.showTowerColumn = true;
    $scope.showTowerInput = true;
    $scope.num = {};
  };
  $scope.hideNumColumn = function () {
    $scope.showTowerColumn = false;
    $scope.showTowerInput = false;
    angular.element('input.b-textfield.-display_inline.num').show();
  };

  $scope.startOver = function (event) {
    event.preventDefault();
    $scope.showTowerColumn = true;
    $scope.showTowerInput = false;
    $scope.num = {};

    for (let i = 1; i <= 5; i++) {
      delete $scope[`numColumn_${i}`];
    }
  };

  $timeout(function () {
    if ($('.b-textfield[data-clean]').data('clean')) {
      $('.js-tabs__link').parent().removeClass('-state_active');
      $('.js-inTowerId').parent().addClass('-state_active');
      $('#pass').removeClass('-state_active');
      $('#id').addClass('-state_active');
      $scope.showTowerColumn = false;
      $scope.showTowerInput = true;
    }
  }, 100);
}

function featuresCtrl($scope, unit, $timeout) {
  const vm = this;

  $scope.featureChoiceList = [];
  $scope.featureLabel = unit.featureLabel;
  $scope.customLabel = unit.customLabel;
  $scope.customField = { type: 1 };

  if (typeof option !== 'undefined') {
    $scope.option = option;
  }

  $scope.changeCustomField = function () {
    if ($scope.customFeature) {
      $scope.customField.type = $scope.customFeature.type;
      $scope.customFeatureValue = '';
      $('.b-house__unit').removeClass('-type_featured');

      if ($scope.customFeature.type == 4 && $scope.customFeature.content) {
        $('.js-customSelect').styler('destroy');
        $scope.featureChoiceList = $scope.customFeature.content.split(';;');
        $scope.customFeatureValue = $scope.featureChoiceList[0];
        $timeout(function () {
          $('.js-customSelect .jq-selectbox__select').remove();
          $('.js-customSelect').styler();
        }, 50);
      }
    }
  };

  $scope.changeFeature = function () {
    if ($('.mdl-button[data-est-mark-feature]').hasClass('-state_done')) {
      $('.b-house__unit').removeClass('-type_featured');
      const parent = $(
        `.b-roomlabels__el[data-feature-id=${$scope.featureId}]`,
      ).parents('.b-house__unit');
      parent.addClass('-type_featured');
    }
  };

  $timeout(function () {
    $('select').trigger('refresh');
    $scope.changeCustomField();
  }, 100);

  $scope.changeChoiceField = function () {
    $scope.customFeatureValue = this.customFeatureValue;

    if ($('.mdl-button[data-est-mark-feature]').hasClass('-state_done')) {
      $('.b-house__unit').removeClass('-type_featured');
      const parent = $(
        `.customField[data-field-value=${$scope.customFeatureValue}]`,
      ).parents('.b-house__unit');
      parent.addClass('-type_featured');
    }
  };

  vm.applyToAll = function (event) {
    event.preventDefault();
    $('.b-house__unit').trigger('click');
  };

  vm.applyToColumn = function (event, params) {
    event.preventDefault();
    angular.forEach(MatrixTower[params[0] - 1].elements, function (el, i) {
      if (el.length > 1) {
        angular.forEach(el, function (subEl, i) {
          $(subEl).trigger('click');
        });
      } else {
        $(el).trigger('click');
      }
    });
  };
}

function imageCtrl(
  $scope,
  Upload,
  api,
  $rootScope,
  unit,
  image,
  $timeout,
  $state,
  $translate,
) {
  let textNone = $translate.instant('unit.popup.none');
  $rootScope.$on('$translateChangeSuccess', function () {
    textNone = $translate.instant('unit.popup.none');
  });
  $scope.$state = $state;
  $scope.imagesMaster = [];
  $scope.imagesFloor = [];
  $scope.imagesUnit = [];
  $scope.imagesViz = [];
  $scope.imagesHouse = [];
  $scope.imagesMasterNone = textNone;
  $scope.imagesFloorNone = textNone;
  $scope.imagesUnitNone = textNone;
  $scope.imagesVizNone = textNone;
  $scope.imagesHouseNone = textNone;

  $scope.uploadFiles = function (file, type) {
    $scope.f = file;
    let imageType = '';
    const dataType = 'section';

    // устанавливаем тип изображения
    switch (type) {
      case 1:
        imageType = 'imagesMaster';
        break;
      case 2:
        imageType = 'imagesFloor';
        break;
      case 3:
        imageType = 'imagesUnit';
        break;
      case 4:
        imageType = 'imagesViz';
        break;
    }

    // если файл выбрали и не произошла ошибка "Файл большого размера"
    if (file && !file.$error) {
      const fields = {
        type: dataType,
        image_type: type,
        token: $rootScope.token,
        id: $rootScope.sectionId,
      };

      file.upload = Upload.upload({
        method: 'POST',
        url: api.images.upload,
        file: file,
        fields: fields,
      }).progress(function (evt) {
        $scope[`${imageType}Progress`] = parseInt(
          (100.0 * evt.loaded) / evt.total,
          10,
        );
      });

      file.upload.then(
        function (response) {
          $('input[type=file]').val(null);
          const { data } = response;

          const dataObj = {
            url: image.url + data.result.path,
            fullUrl: `https://res.cloudinary.com/estoffice-com/image/upload/v1/${data.result.path}`,
            name: data.result.name,
            title: $rootScope.imageTitle,
            id: data.result.id,
          };

          if (angular.isArray($scope[imageType])) {
            $scope[imageType].push(dataObj);
          } else {
            $scope[imageType] = dataObj;
          }

          $timeout(function () {
            $scope[`${imageType}Progress`] = -1;
          });
        },
        function (response) {
          if (response.status > 0) {
            $scope.errorMsg = `${response.status}: ${response.data}`;
          }
        },
      );
    } else if (file.$error) {
      if (file.$error == 'maxSize') {
        alert('Your file exceeds 20MB. Please, resize.');
      }
    }
  };

  $scope.countImages = unit.images;
  $scope.countFloor = unit.imagesFloor;

  $scope.setImageFloors = function (imageId, imageType, unitIds, bind, floors) {
    // called from a React event handler, outside any Angular digest - $timeout
    // schedules the mutation and triggers the digest the floors list needs to notice it
    $timeout(function () {
      unit.imagesFloor[imageId] = floors;

      // keep the legacy mark-mode grid's DOM markers in sync, since it
      // reads .js-imageHighlight presence instead of unit.imagesFloor
      unitIds.forEach(function (unitId) {
        const cell = $(`.b-houseroom[data-unit-id="${unitId}"]`);
        const marker = cell.find(
          `.js-imageHighlight[data-image-id="${imageId}"]`,
        );

        if (bind) {
          if (!marker.length) {
            cell.append(
              `<input type="hidden" class="js-imageHighlight" data-image-id="${imageId}" data-image-type="${imageType}" data-attach-image>`,
            );
          }

          cell.addClass('-type_featured -mark_highlight');
        } else {
          marker.remove();
          cell.removeClass('-mark_highlight');
        }
      });
    });
  };
}

function reviewCtrl($scope) {}

function priceCtrl($rootScope, $scope, $timeout, api, unit) {
  const vm = this;
  $scope.price = {};
  $timeout(function () {
    unit.priceId = $scope.price.id;
    $scope.price.type = 'price';
    $scope.price.url = `${api.price.change.replace(
      '{{sectionId}}',
      $rootScope.sectionId,
    )}?pl=${unit.priceId}`;
  }, 5);

  $scope.changePrice = function (event, id) {
    //event.preventDefault();
    $('.js-price').removeClass('active');
    $(event.currentTarget).addClass('active');
    unit.priceId = id;
  };
}

function productionCtrl(
  $scope,
  $timeout,
  $state,
  $location,
  $rootScope,
  $http,
  $window,
) {
  const vm = this;

  vm.heightOnMobile = { height: `${$window.innerHeight - 88}px` };

  vm.publicLink = `https://${$location.host()}/section/${
    $rootScope.sectionId
  }/public`;

  // used in Mousetrap keyboard shortcuts
  vm.filterRooms = function (event, params) {
    const el = `#rooms${params[0]}`;

    // timeout so event happens not during $apply
    $timeout(function () {
      angular.element(el).trigger('click');
    }, 100);
  };

  const unitsContainer = document.getElementById('b-units');
  vm.scrollToRight = function (event) {
    unitsContainer.scrollLeft = 1600;
    $('.js-scrollbars').perfectScrollbar('update');
  };

  vm.scrollToLeft = function (event) {
    unitsContainer.scrollLeft = 0;
    $('.js-scrollbars').perfectScrollbar('update');
  };

  vm.resetFilter = function () {
    // timeout so event happens not during $apply
    $timeout(function () {
      // call resetQuery() in unit.search.panel.controller.ts
      $rootScope.$broadcast('unit.search.panel:resetFilters');
    }, 100);
  };

  // открытие ссылки на юнит открывает соответствующий попап юнита
  const unitId = window.location.hash.split('/')[1];

  if (unitId) {
    $timeout(function () {
      $(`.b-house__unit[data-unit-id=${unitId}]`).trigger('click');
    });
  }

  // Для открытия/закрытия попапов
  $scope.$state = $state;
}

function productionLocationCtrl($scope, $rootScope) {
  const vm = this;
  vm.publicMode = isPublicMode();

  $scope.firstSelect = function () {
    let url = '/objects/object_section/{{ID}}'.replace(
      '{{ID}}',
      $scope.firstSelectValue,
    );

    if (vm.publicMode) {
      url += '?public=true';
    }

    window.location = url;
  };

  $scope.secondSelect = function () {
    let url = '/objects/house_section/{{ID}}'.replace(
      '{{ID}}',
      $scope.secondSelectValue,
    );

    if (vm.publicMode) {
      url += '?public=true';
    }

    window.location = url;
  };

  $scope.blockSelect = function () {
    const url = '/objects/house_section/{{ID}}?edit=1'.replace(
      '{{ID}}',
      $scope.blockSelectValue,
    );
    window.location = url;
  };

  $scope.editingFirstSelect = function () {
    const segments = window.location.pathname.split('/');
    const page = segments[segments.length - 1];

    const url = '/objects/object_section/{{ID}}/?edit={{ACTION}}'
      .replace('{{ID}}', $scope.blockSelectValue)
      .replace('{{ACTION}}', page);

    window.location = url;
  };

  $scope.editingSecondSelect = function () {
    const segments = window.location.pathname.split('/');
    const page = segments[segments.length - 1];

    const url = '/objects/house_section/{{ID}}/?edit={{ACTION}}'
      .replace('{{ID}}', $scope.secondSelectValue)
      .replace('{{ACTION}}', page);

    window.location = url;
  };
}
